import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/customer-login/page.tsx");
